//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import angular from 'angular';

import template from './streams-drawer-stream-description.html';

import { DEFAULT_DATE_RANGE_STRING, SEMANTIC_STREAM_NAME, StreamsDrawerStreamType } from '@streams-drawer/streams-drawer-constants';
import { IStream } from '../model/IStream';

class StreamsDrawerStreamDescription {
  public stream: IStream;
  public streamType: StreamsDrawerStreamType;

  public date: string;
  public semanticTag: string;
  public link: {
    target: string,
    text: string,
  };

  // Get date string (e.g. 3 months, 7 days, recently, etc)
  public getDate() {
    const dateRange = this.stream.filters.dateRange;
    let dateRangeNumber;
    let dateRangeUnit;

    if (!dateRange) {
      return DEFAULT_DATE_RANGE_STRING;
    }

    const dateMatch = dateRange.match(/(\d+)(\w+)/i);
    if (dateMatch !== null) {
      dateRangeNumber = dateMatch[1].toLowerCase();
      dateRangeUnit = dateMatch[2].toLowerCase();
    }

    if (dateMatch !== null) {
      return 'in the last ' + dateRangeNumber + ' ' + dateRangeUnit;
    } else {
      return DEFAULT_DATE_RANGE_STRING;
    }
  }

  // Strip semantic tag from stream name
  public getTag() {
    const semanticPattern = new RegExp(`${SEMANTIC_STREAM_NAME}(.*)`);
    const match = this.stream.name.match(semanticPattern);
    if (match !== null) {
      return this.semanticTag = match[1].trim().toLowerCase();
    } else {
      return '';
    }
  }

  // Determines media source and links to it
  public getSourceLink() {
    const sources = this.stream.sources;
    if (sources.allInstagram) {
            // Media is coming from all tracked sources
      return {
        target: '/library/tracked-sources/hashtags',
        text: 'tracked sources',
      };
    } else {
      if (sources.instagramMentions && sources.instagramMentions.length > 0) {
        // Media is coming from instagram mentions
        return {
          target: '/instagram/mentioned-and-tagged',
          text: 'account mentions',
        };
      } else {
        // Media is coming from elsewhere. Leave blank
        return {
          target: '',
          text: '',
        };
      }
    }
  }

  public $onInit() {
    this.date = this.getDate();
    if (this.streamType === StreamsDrawerStreamType.SEMANTIC) {
      this.semanticTag = this.getTag();
    }
    this.link = this.getSourceLink();
  }

  public $onChanges(changeObj) {
    if (changeObj.stream) {
      this.date = this.getDate();
      if (this.streamType === StreamsDrawerStreamType.SEMANTIC) {
        this.semanticTag = this.getTag();
      }
      this.link = this.getSourceLink();
    }
  }
}

angular.module('curalate').component('streamsDrawerStreamDescription', {
  bindings: {
    stream: '<',
    streamType: '<',
  },
  controller: StreamsDrawerStreamDescription,
  template,
});
